module.exports = {
  "/": {
    "name": "index-redirect"
  },
  "/account-defaults": {
    "name": "account-defaults-redirect"
  },
  "/account-defaults/general": {
    "success": [
      "LANGUAGE_CHOOSER",
      "LOCALE_CHOOSER",
      "TIME_ZONE",
      "CURRENCY",
      "GDPR_COMPLIANCE"
    ],
    "error": [
      "LANGUAGE_CHOOSER_FAILURE",
      "LOCALE_CHOOSER_FAILURE",
      "TIME_ZONE_FAILURE",
      "CURRENCY_FAILURE",
      "GDPR_COMPLIANCE_FAILURE"
    ]
  },
  "/account-defaults/multicurrency": {
    "success": [
      "MULTI_CURRENCY_LOADED"
    ],
    "error": [
      "MULTI_CURRENCY_LOADED_FAILURE"
    ]
  },
  "/account-defaults/branding": {
    "success": [
      "BRANDING_COMPANY_INFO_LOADED"
    ],
    "error": [
      "BRANDING_COMPANY_INFO_LOADED_FAILURE"
    ]
  },
  "/account-defaults/branding/logo": {
    "success": [
      "BRANDING_COMPANY_LOGO_LOADED",
      "BRANDING_COMPANY_AVATAR_LOADED"
    ],
    "error": [
      "BRANDING_COMPANY_LOGO_LOADED_FAILURE",
      "BRANDING_COMPANY_AVATAR_LOADED_FAILURE"
    ]
  },
  "/account-defaults/branding/colors": {
    "success": [
      "BRANDING_COLORS_LOADED"
    ],
    "error": [
      "BRANDING_COLORS_LOADED_FAILURE"
    ]
  },
  "/goals": {
    "success": [
      "QUOTAS_LOADED"
    ]
  },
  "/analytics-and-tracking": {
    "name": "analytics-and-tracking-redirect"
  },
  "/analytics-and-tracking/tracking": {
    "name": "analytics-and-tracking-index",
    "success": [
      "ANALYTICS_AND_TRACKING_PAGE_LOADED"
    ]
  },
  "/analytics-and-tracking/domains": {
    "success": [
      "ADDITIONAL_DOMAINS_LOADED",
      "DOMAIN_CONFIGURATION_LOADED",
      "EXCLUDED_TRAFFIC_LOADED"
    ],
    "error": [
      "ADDITIONAL_DOMAINS_LOADED_FAILURE",
      "DOMAIN_CONFIGURATION_LOADED_FAILURE",
      "EXCLUDED_TRAFFIC_LOADED_FAILURE"
    ]
  },
  "/analytics-and-tracking/analytics-views": {
    "success": [
      "ANALYTICS_VIEWS_LOADED"
    ]
  },
  "/analytics-and-tracking/cookies": {
    "success": [
      "COOKIE_POLICY_LOADED"
    ],
    "error": [
      "COOKIE_POLICY_LOADED_FAILURE"
    ]
  },
  "/ecommerce": {
    "name": "ecommerce",
    "success": [
      "ECOMMERCE_SETTINGS_LOADED"
    ],
    "error": [
      "ECOMMERCE_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/email-service-provider": {
    "name": "marketing-email-service-provider",
    "success": [
      "ESP_SYNC_LOADED"
    ]
  },
  "/marketing/form": {
    "name": "marketing-form-redirect"
  },
  "/marketing/form/non-hubspot": {
    "name": "marketing-form-non-hubspot",
    "success": [
      "COLLECTED_FORMS_SETTINGS_LOADED"
    ],
    "error": [
      "COLLECTED_FORMS_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/marketing/form/styles": {
    "name": "marketing-form-styles",
    "success": [
      "FORM_STYLE_LOADED"
    ],
    "error": [
      "FORM_STYLE_LOADED_FAILURE"
    ]
  },
  "/marketing/form/submissionssettings": {
    "name": "marketing-form-submissionssettings",
    "success": [
      "FORM_SUBMISSIONS_SETTINGS_LOADED"
    ],
    "error": [
      "FORM_SUBMISSIONS_SETTINGS_LOADED_FAILURE"
    ]
  },
  "/sales/meetings": {
    "name": "sales-meetings",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ]
    }
  },
  "/sales/meetings/calendar": {
    "name": "sales-meetings-calendar",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ],
      "content loaded": [
        "MEETINGS_SETTINGS_LOADED"
      ]
    }
  },
  "/sales/meetings/domain": {
    "name": "sales-meetings-domain",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ],
      "content loaded": [
        "MEETINGS_SETTINGS_LOADED"
      ]
    }
  },
  "/sales/meetings/integration": {
    "name": "sales-meetings-integration",
    "success": {
      "empty state": [
        "MEETINGS_EMTPY_STATE_LOADED"
      ]
    }
  }
};